import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccountOcrMutation } from '@/domain/account';
import { KbPaymentForm } from '@/pages/transactions/components/KbTransactions/components/PaymentForm/PaymentSchema';

export const useOcrCheck = () => {
    const mutate = useAccountOcrMutation();
    const methods = useFormContext<KbPaymentForm>();
    const accountNumber = methods.watch('payeeAccountNumber');

    useEffect(() => {
        const check = async () => {
            if (accountNumber !== '') {
                methods.setValue('ocrKid', 'init');
                const valid = await methods.trigger('payeeAccountNumber');

                if (valid) {
                    try {
                        const response = await mutate.mutateAsync(accountNumber.replaceAll('.', ''));
                        if (response.kidRequired) {
                            methods.setValue('ocrKid', 'required');
                        } else {
                            methods.setValue('ocrKid', 'not_required');
                        }

                        if (response.name) {
                            methods.setValue('payeeName', response.name);
                        }
                    } catch (err) {
                        methods.setValue('ocrKid', 'error');
                    }
                }
            }
        };
        check();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accountNumber]);
};
